<template>
    <div>
        <!--left arrow-->
        <div class="hidden-md hidden-lg hidden-sm">
            <div v-if="slideRight && canSlideRight">
                <transition name="link-slide-right" mode="out-in">
                    <a class="arrow arrow-left"
                       href="javascript:void(0)"
                       @click="left"
                       v-if="!leftMostReached()" :key="idx">
                        <span>&larr;</span> {{dict[idx - 1].term}}</a>
                </transition>
            </div>
            <div v-else>
                <transition name="link-slide-left" mode="out-in">
                    <a class="arrow arrow-left"
                       href="javascript:void(0)"
                       @click="left"
                       v-if="!leftMostReached()" :key="idx">
                        <span>&larr;</span> {{dict[idx - 1].term}}</a>
                </transition>
            </div>
        </div>
        <div class="hidden-xs">
            <a class="arrow arrow-left" href="javascript:void(0)"
               @click="left"
               v-if="!leftMostReached()" :key="idx">
                <span>&larr;</span> {{dict[idx - 1].term}}</a>
        </div>
        <!--end of left arrow-->
        <!--Main Description Area-->
        <div class="word-wrapper">
            <v-touch @swipeleft="right" @swiperight="left">
                <div v-if="slideRight && canSlideRight">
                    <transition name="slide-right" mode="out-in">
                        <word :word="dict[idx]"
                              :key="dict[idx].term"
                              :canDisplayDefinition="true"></word>
                    </transition>
                </div>
                <div v-else>
                    <transition name="slide-left" mode="out-in">
                        <word :word="dict[idx]"
                              :key="dict[idx].term"
                              :canDisplayDefinition="true"></word>
                    </transition>
                </div>
            </v-touch>
        </div>
        <!--right arrow-->
        <div class="hidden-md hidden-lg hidden-sm">
            <div v-if="slideRight && canSlideRight">
                <transition name="link-slide-right" mode="out-in">
                    <a class="arrow arrow-right"
                       href="javascript:void(0)"
                       @click="right"
                       v-if="!rightMostReached()"
                       :key="idx">{{dict[idx + 1].term}}
                        <span>&rarr;</span>
                    </a>
                </transition>
            </div>
            <div v-else>
                <transition name="link-slide-left" mode="out-in">
                    <a class="arrow arrow-right"
                       href="javascript:void(0)"
                       @click="right"
                       v-if="!rightMostReached()"
                       :key="idx">{{dict[idx + 1].term}}
                        <span>&rarr;</span>
                    </a>
                </transition>
            </div>
        </div>
        <div class="hidden-xs">
            <a class="arrow arrow-right" href="javascript:void(0)"
               @click="right"
               v-if="!rightMostReached()"
               :key="idx">{{dict[idx + 1].term}}
                <span>&rarr;</span>
            </a>
        </div>
        <!--end of right arrow-->
    </div>
</template>

<script>
    import Word from './Word';

    export default {
        name: "WordContainer",
        props: {
            currentIdx: {
                type: Number,
                required: true
            },
            dict: {
                type: Array,
                required: true
            },
            canSlideRight: {
                type: Boolean,
                required: true
            }
        },
        components: {
            "word": Word,
        },
        methods: {
            left: function () {
                if (this.idx <= this.skipFront) {
                    this.idx = this.skipFront;
                } else {
                    this.idx--;
                }
                if (this.currentActiveLetter !== this.dict[this.idx].term[0]) {
                    this.currentActiveLetter = this.dict[this.idx].term[0];
                }
                this.slideRight = false;
                let letter = this.isLetter(this.dict[this.idx].term[0]) ? this.dict[this.idx].term[0] : "#";
                this.$emit("getCurrentActiveLetterFromBottomArrows", letter);
                this.$emit("getCurrentIdxFromBottomArrows", this.idx);
            },
            right: function () {
                if (this.idx >= this.dictLength - this.skipBack - 1) {
                    this.idx = this.dictLength - this.skipBack - 1;
                } else {
                    this.idx++;
                }
                if (this.currentActiveLetter !== this.dict[this.idx].term[0]) {
                    this.currentActiveLetter = this.dict[this.idx].term[0];
                }
                this.slideRight = true;
                let letter = this.isLetter(this.dict[this.idx].term[0]) ? this.dict[this.idx].term[0] : "#";
                this.$emit("getCurrentActiveLetterFromBottomArrows", letter);
                this.$emit("getCurrentIdxFromBottomArrows", this.idx);
            },
            leftMostReached: function () {
                return (this.idx - 1) === -1 || this.dict[this.idx - 1].term === "*";
            },
            rightMostReached: function () {
                return (this.idx + 1) === this.dictLength || this.dict[this.idx + 1].term === "*";
            },
            isLetter: function (str) {
                return str.length === 1 && str.match(/[a-z]/i);
            }
        },
        data: function () {
            return {
                currentActiveLetter: 'A',
                slideRight: true,
                idx: this.currentIdx,
                dictLength: this.dict.length,
                skipFront: 6,
                skipBack: 13
            }
        },
        watch: {
            currentIdx: function () {
                this.idx = this.currentIdx;
            }
        }
    }

</script>

<style scoped lang="scss">
    .word-wrapper {
        position: relative;
        text-align: center;
        margin: 0 auto;
        @media screen and (min-width: 320px) {
            padding-left: 5px;
            padding-right: 5px;
            top: 10px;
        }
        @media screen and (min-width: 480px) {
            top: 40px;
        }
        @media screen and (min-width: 768px) {
            top: 100px;
        }
        @media screen and (min-width: 1024px) {
            top: 150px;
        }
    }

    a {
        font-family: "Frutiger LT W01_77 Black Cond", 'Avenir', Helvetica, Arial, sans-serif;
        text-decoration: none;
        color: black;
        margin-right: 10px;
        vertical-align: middle;
        display: inline-block;
        span {
            color: black;
            margin-left: 5px !important;
            margin-right: 5px !important;
            font-size: 26px;
            display: inline-block;
            vertical-align: middle;

            @media only screen and (min-width: 480px) {
                margin-left: 15px;
                margin-right: 15px;
            }
        }
    }
    @media(hover) {
        a:hover {
            text-decoration: underline;
        }
    }

    .arrow {
        font-size: 22px;
        span {
            font-size: 26px;
            position: relative;
            top: -4px;
            left: 0;
        }
        @media only screen and (min-width: 320px) {
            font-size: 12px;
            span {
                font-size: 16px;
                position: relative;
                top: -2px;
                left: 0;
            }
        }
        @media only screen and (min-width: 480px) {
            font-size: 22px;
            span {
                font-size: 32px;
            }
        }
    }

    .arrow-left {
        color: #D40511;
        text-align: left;
        z-index: 11;
        @media only screen and (min-width: 320px) {
            position: relative;
            top: 0;
            left: 10px;
        }
        @media only screen and (min-width: 480px) {
            position: relative;
            bottom: 20px;
            left: 10px;
            top: unset;
            top: initial;
        }
        @media only screen and (min-width: 768px) {
            position: relative;
            left: 10px;
            bottom: 10px;
        }
        @media only screen and (min-width: 1024px) {
            position: absolute;
            left: -6rem;
            bottom: 10px;
        }

    }

    .arrow-right {
        position: absolute;
        color: #D40511;
        text-align: right;
        z-index: 11;
        @media only screen and (min-width: 320px) {
            bottom: 10px;
            right: 10px;
        }
        @media only screen and (min-width: 480px) {
            right: 20px;
            bottom: 10px;
        }
        @media only screen and (min-width: 768px) {
            right: 5px;
        }
        @media only screen and (min-width: 1024px) {
            right: 0.5rem;
        }
    }

    .slide-right-leave-active,
    .slide-right-enter-active {
        transition: 0.65s;
    }

    .slide-right-enter {
        transform: translate(150%, 0);
    }

    .slide-right-leave-to {
        transform: translate(-150%, 0);
    }

    .slide-left-leave-active,
    .slide-left-enter-active {
        transition: 0.65s;
    }

    .slide-left-enter {
        transform: translate(-150%, 0);
    }

    .slide-left-leave-to {
        transform: translate(150%, 0);
    }

    /* left arrow link*/

    .link-slide-left-leave-active,
    .link-slide-left-enter-active {
        transition: 0.75s;
    }

    .link-slide-left-enter {
        transform: translate(-500%, 0);
    }

    .link-slide-left-leave-to {
        transform: translate(500%, 0);
    }

    /* right arrow link */

    .link-slide-right-leave-active,
    .link-slide-right-enter-active {
        transition: 0.75s;
    }

    .link-slide-right-enter {
        transform: translate(500%, 0);
    }

    .link-slide-right-leave-to {
        transform: translate(-500%, 0);
    }


</style>



// WEBPACK FOOTER //
// src/components/WordContainer.vue